export default __webpack_public_path__ + "static/media/features-thumb-1.e1d97883.png";